import axios from '../../axios'

/*
 * 目标学时管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/target/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/target/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/target/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/target/detail',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/tag/tag.js